import { render, staticRenderFns } from "./ViolationStudent.vue?vue&type=template&id=16b2cdae&scoped=true&"
import script from "./ViolationStudent.vue?vue&type=script&lang=js&"
export * from "./ViolationStudent.vue?vue&type=script&lang=js&"
import style0 from "./ViolationStudent.vue?vue&type=style&index=0&id=16b2cdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b2cdae",
  null
  
)

export default component.exports